module.exports = __webpack_public_path__ + "static/media/img-photo.d2b65303.svg";